import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import swal from 'sweetalert';
import './global.css';

const Myproject = ({ project }) => {
    const [expand, setExpand] = useState(false);
    const { title, img, imgPro, description, tech, Live, github } = project;
    // console.log(project);

    const goingGitHub = (url) => {
        if (url) {
            window.open(
                `${url}`,
                "_blank"
            );
        }
        else {
            swal({
                title: "Attention",
                text: "Code link can’t providable because it’s company rules.",
                icon: "warning",
                dangerMode: true,
            })
        }
    };

    const goingLive = (live) => {

        window.open(
            `${live}`,
            "_blank"
        );

    }

    return (
        <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-up" data-aos-duration="2000">
            <Card style={{ height: "auto" }} className='shadow mb-5 bg-dark text-light rounded mx-auto font-monospace widthforrespo'>
                <a href={imgPro} target='_blank' rel="noreferrer"> <Card.Img variant="top" src={img} className='img-fluid' style={{ height: '350px' }} /></a>
                <Card.Body>
                    <Card.Title className='fw-bolder fs-4 text-center' style={{ color: "khaki" }}>{title}</Card.Title>
                    <Card.Text style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>
                        <p>{!expand && description.slice(0, 150) + '...'}{!expand && <button onClick={() => setExpand(true)} className='bg-dark border-0 text-info fst-italic fst-normal'>read more</button>}
                            {expand && description}{expand && <button onClick={() => setExpand(false)} className='bg-dark border-0 text-info fst-italic fst-normal'>read less</button>}
                        </p>
                        <p>{tech}</p>
                    </Card.Text>
                    <div className='d-flex justify-content-evenly align-items-center pt-4'>
                        <button className='button-metamask px-4' onClick={() => goingLive(Live)} target={"_blank"}>Live Site</button>
                        <button className='button-metamask px-4' onClick={() => goingGitHub(github)}>GitHub Link</button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default Myproject;